<template>
	<dynvibebasechart
		:id="axiosComputed"
		ref="basechart"
		@created="chartCreated"
		:functionClick="clickGraph"
		:type="type"
	></dynvibebasechart>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";

export default {
	name: "dynvibebaropposite",
	mixins: [graphMixin],
	methods: {
		setChartOptions() {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			chartOptions.xAxis.reversed = false;
			let xAxis1 = Object.assign({}, chartOptions.xAxis);
			let xAxis2 = Object.assign({}, chartOptions.xAxis);
			xAxis2.opposite = true;
			xAxis2.linkedTo = 0;
			chartOptions.xAxis = [xAxis1, xAxis2];
			(chartOptions.yAxis.labels.formatter = function () {
				return Math.abs(this.value);
			}),
				(chartOptions.tooltip = {
					formatter: function () {
						return (
							this.x +
							'<br/><span style="color:' +
							this.point.color +
							'">\u25CF</span> ' +
							this.point.series.name +
							": <b>" +
							Math.abs(this.point.y) +
							"</b>"
						);
					},
				}),
				baseChart.updateChartOptions(chartOptions);
		},
		loadChartData(results) {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			chartOptions.xAxis[0].categories = results.categories;
			chartOptions.xAxis[1].categories = results.categories;
			chartOptions.series = results.values;
			baseChart.updateChartOptions(chartOptions);
		},
	},
};
</script>
